import Vue from "vue";

export default {
	extends: Vue,
	props: {
		showExport: false,
		showExportReverseGeocoding: false,
		showExportPdf: false,
		showEdit: false,
		showUndo: false,
		showSave: false,
		showAdd: false,
		forceShowAdd: false,
		isInEditMode: false,

		disabledEditMode: false
	},
	components: {},
	data: function() {
		return {
			//changes: false
		};
	},
	watch: {
		isInEditMode: function() {
			var tooltipsToRmove = [];

			if (this.$root && this.$root.$el && this.$root.$el.parentNode && this.$root.$el.parentNode.childNodes) {
				this.$root.$el.parentNode.childNodes.forEach(function(x) {
					if (x.className == "k-animation-container") tooltipsToRmove.push(x);
				});
			}
			
			tooltipsToRmove.forEach(function(f) {
				if (f && f.style) {
					f.style.display = "none";
				}
			})
		}
	},
	methods: {
		downloadPdf() {
			this.$emit("download-pdf");
		},
		downloadXlsx() {
			this.$emit("download-xlsx");
		},
		downloadCsv() {
			this.$emit("download-csv");
		},
		downloadXlsxReverseGeocoding() {
			this.$emit("download-xlsx-rg");
		},
		downloadCsvReverseGeocoding() {
			this.$emit("download-csv-rg");
		},

		saveData() {
			this.$emit("save-data-items");
		},
		switchEditMode() {
			//this.changes=!this.changes;
			//this.isInEditMode=!this.isInEditMode;
			this.$emit("switch-edit-mode");
		},
		addItems() {
			this.$emit("add-item");
		}
	}
};
